export default __webpack_public_path__ + "static/media/schoolMarker.688d9819.svg";